import React from "react";
import HomepageComponent from "../components/homepage/homepage-component";

export default function Homepage() {
    return (
        <HomepageComponent />
    )
}